import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import Subtotal_US from "./Subtotal_US";
import Subtotal_Korea from "./Subtotal_Korea";
import FeaturedProductsBestSellers from "./FeaturedProductsBestSellers";
import FeaturedProductRecent from "./FeaturedProductRecent";
import { useStateContext } from "../../../context/StateContext_KO";

import { useAuth } from "../../../context/AuthContext";
import { useProductContext } from "../../../context/ProductContext";
import Fade from "react-reveal/Fade";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Alert from "@mui/material/Alert";
import { collection, getDocs, db } from "../../../firebase";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import CurrencyFormat from "react-currency-format";

const Cart = () => {
  let currentLocation = JSON.parse(
    window.sessionStorage.getItem("iplookup")
  ).countryCode;
  currentLocation = "KO";

  const { MAXIMUM_QUANTITY } = useProductContext();
  const {
    basket,
    removeItemFromBasket,
    ChangeQuantityToBasket,
    getBasketQuantity,
  } = useStateContext();

  const { currentUser } = useAuth();
  const { t, i18n } = useTranslation();
  const [modifyBasketId, setModifyBasketId] = useState(null);
  const [modifyBasketImage, setModifyBasketImage] = useState(null);
  const [modifyBasketName, setModifyBasketName] = useState(null);
  const [modifyBasketNewNumber, setModifyBasketNewNumber] = useState(0);
  const [valid, setValid] = useState(true);
  const [msg, setMsg] = useState("");
  const [modifyMsg, setModifyMsg] = useState("");

  const [products, setProducts] = useState([]);

  const showMsg = () => {
    setMsg("Please add an item to check out.");
    setTimeout(() => {
      setMsg("");
    }, 1000);
  };

  useEffect(() => {
    console.log("basket", basket);
  }, [basket]);

  useEffect(() => {
    const getProducts = async () => {
      const querySnapshot = await getDocs(collection(db, "KO_products"));
      querySnapshot.forEach((doc) => {
        setProducts((old) => [...old, { id: doc.id, ...doc.data() }]);
      });
    };
    getProducts();
  }, []);

  function isInt(value) {
    return (
      !isNaN(value) &&
      parseInt(Number(value)) === value &&
      !isNaN(parseInt(value, 10))
    );
  }
  const checkNumber = (number) => {
    if (isInt(number)) {
      setValid(true);
    } else {
      setValid(false);
    }
    setModifyBasketNewNumber(number);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (id, image, name, quantity) => {
    setModifyBasketId(id);
    setModifyBasketImage(image);
    setModifyBasketName(name);
    setModifyBasketNewNumber(quantity);

    setOpen(true);
  };
  const minus = () => {
    if (modifyBasketNewNumber > 1) {
      setModifyBasketNewNumber((old) => old - 1);
    } else {
      removeItem();
    }
  };
  const plus = () => {
    let basketQuantity;
    products.map((product) => {
      if (modifyBasketId === product.id) {
        console.log(product.quantity);
        basketQuantity = product.quantity;
      }
    });

    if (modifyBasketNewNumber < basketQuantity) {
      setModifyBasketNewNumber((old) => old + 1);
    } else {
      setModifyMsg(
        "죄송합니다. 주문하실수 있는 최대 갯수는 " + basketQuantity + " 입니다"
      );
      setModifyBasketNewNumber(basketQuantity);
    }
  };
  useEffect(() => {
    setModifyMsg("");
  }, [modifyBasketId]);

  const handleClose = () => {
    setOpen(false);
  };
  const removeItem = () => {
    console.log(modifyBasketId);
    removeItemFromBasket(modifyBasketId);
    handleClose();
  };
  const update = () => {
    console.log("modifyBasketNewNumber", modifyBasketNewNumber);
    ChangeQuantityToBasket(modifyBasketId, modifyBasketNewNumber);
    setOpen(false);
  };

  return (
    <Fade delay={300}>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            px: 10,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid lightgray",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img src={modifyBasketImage} alt="" width="90" />
            <Box
              sx={{
                pl: 2,
                fontSize: "13px",
                pt: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ fontSize: "15px" }}>{t("Update Quantity")}</Box>
              <Box sx={{ color: "#b1b1b1" }}>{t(modifyBasketName)}</Box>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent
          sx={{
            my: 2,
            mt: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              mb: 4,
              display: "flex",
              alignItems: "center",
            }}
          >
            <RemoveCircleOutlineIcon
              sx={{
                pr: 2,
                fontSize: "32px",
                color: "#455a64",
                cursor: "pointer",
              }}
              onClick={minus}
            />
            <TextField
              value={modifyBasketNewNumber}
              autoFocus
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              sx={{
                width: "70px",
                border: valid ? "1px solid lightgray" : "1px solid red",
                borderRadius: "5px",
                outline: "none",
                "&:focus": { outline: "none" },
                textAlign: "center",
              }}
              onChange={(event) => checkNumber(event.target.value)}
            />
            <AddCircleOutlineIcon
              sx={{
                pl: 2,
                fontSize: "32px",
                color: "#455a64",
                cursor: "pointer",
              }}
              onClick={plus}
            />
          </Box>

          {modifyMsg && (
            <Alert severity="warning" sx={{ mb: 2, fontSize: "11px" }}>
              {modifyMsg}
            </Alert>
          )}

          <button
            className="custom_btn_whitebg"
            style={{ marginBottom: "20px" }}
            onClick={removeItem}
          >
            {t("Remove Item")}
          </button>
          <button className="custom_btn" onClick={update}>
            {t("Update")}
          </button>
        </DialogContent>
      </Dialog>
      <Grid
        container
        sx={{
          maxWidth: "1150px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Grid
          item
          md={8}
          sm={12}
          sx={{
            fontWeight: "bold",
            fontSize: "32px",
            boxSizing: "border-box",
            px: 3,
          }}
        >
          <Box className="menu_bredcrumb" sx={{ pt: 5 }}>
            <HashLink smooth to="/">
              {t("bread_home")}{" "}
            </HashLink>
            /{" "}
            <HashLink smooth to="/cart#top">
              {t("bread_cart")}
            </HashLink>
          </Box>
          <Box
            sx={{
              paddingTop: "20px",
              width: 1,
              paddingBottom: "30px",
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid lightgray",
            }}
          >
            <Box sx={{ fontSize: "22px" }}>{t("shoppingcart")}</Box>
            <Box sx={{ fontSize: "12px", color: "gray" }} className="pink_link">
              <HashLink to="/products-cleansing">
                {t("Continue to Shop")}
              </HashLink>
            </Box>
          </Box>
          <Box
            sx={{ paddingBottom: "30px", borderBottom: "1px solid lightgray" }}
          >
            {basket?.map((basketEach) => {
              return (
                <Box
                  sx={{
                    paddingBottom: "25px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "normal",
                    pl: 3,
                  }}
                >
                  <Box className="animation">
                    <HashLink to={"/product/" + basketEach.linkTo + "#top"}>
                      <Box sx={{ backgroundColor: "#f8f7f5", py: 2, px: 2 }}>
                        <img
                          src={basketEach.image}
                          alt=""
                          width="80"
                          height="80"
                        />
                      </Box>
                    </HashLink>
                  </Box>

                  <Box
                    sx={{
                      fontSize: "14px",
                      display: "flex",
                      flexDirection: "column",
                      pl: 4,
                      cursor: "pointer",
                      alignItems: "flex-start",
                      width: 1,
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "space-between",
                        width: 1,
                      }}
                    >
                      <Box sx={{ fontSize: "13px" }}>
                        <HashLink to={"/product/" + basketEach.linkTo + "#top"}>
                          {t(basketEach.name)}
                        </HashLink>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          border: "1px solid lightgray",
                          p: "6px",
                          paddingLeft: "13px",
                        }}
                        onClick={() => {
                          handleClickOpen(
                            basketEach.id,
                            basketEach.image,
                            basketEach.name,
                            basketEach.quantity
                          );
                        }}
                      >
                        <span
                          style={{
                            color: "gray",
                            position: "relative",
                            top: "+5px",
                          }}
                        >
                          {basketEach.quantity}
                        </span>
                        <KeyboardArrowDownIcon sx={{ color: "gray", pl: 3 }} />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        fontSize: "13px",
                        position: "relative",
                        top: "-8px",
                        pb: "4px",
                      }}
                    >
                      <CurrencyFormat
                        value={basketEach.price}
                        displayType={"text"}
                        thousandSeparator={true}
                        suffix={"원"}
                        style={{ color: "#213329" }}
                      />
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          textDecoration: "underline",
                          pr: 2,
                          fontSize: "12px",
                          color: "#757575",
                        }}
                        onClick={() => {
                          handleClickOpen(
                            basketEach.id,
                            basketEach.image,
                            basketEach.name,
                            basketEach.quantity
                          );
                        }}
                      >
                        {t("Edit")}
                      </Box>
                      <Box
                        onClick={() => {
                          removeItemFromBasket(basketEach.id);
                        }}
                        sx={{
                          textDecoration: "underline",
                          pr: 2,
                          fontSize: "12px",
                          color: "#757575",
                        }}
                      >
                        {t("Delete")}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
          {/* <Box sx={{ mt: 6 }}>
            <LocalShippingIcon
              sx={{
                color: "white",
                backgroundColor: "#bdbdbd",
                borderRadius: "50%",
                padding: "10px",
                fontSize: "30px",
              }}
            />
          </Box> */}
        </Grid>
        <Grid item md={4} sm={12} sx={{ pt: 2 }}>
          <Box
            sx={{
              width: 1,
              // borderBottom: "1px solid lightgray",
              pb: 3,
            }}
          ></Box>
          <Box sx={{ px: { md: 0, sm: 3, xs: 3 } }}>
            <FormControl>
              {/* <FormLabel id="demo-row-radio-buttons-group-label">
                {t("Shipping to")}
              </FormLabel> */}
              {/* <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={currentLocation}
              >
                <FormControlLabel
                  value="female"
                  control={
                    <Radio
                      value="US"
                      onClick={() => setCurrentLocation("US")}
                    />
                  }
                  label={t("USA")}
                />
                <FormControlLabel
                  value="male"
                  control={
                    <Radio
                      value="Korea"
                      onClick={() => setCurrentLocation("Korea")}
                    />
                  }
                  label={t("Korea")}
                />
              </RadioGroup> */}
            </FormControl>
            {getBasketQuantity() === 0 ? (
              <Box sx={{ pt: 5 }}>
                {t("oops")}
                <br />
                <br />

                <HashLink smooth to="/products-cleansing">
                  <button className="custom_btn" style={{ marginTop: "20px" }}>
                    {t("start_shopping")}
                  </button>
                </HashLink>
              </Box>
            ) : (
              <>
                {/* {currentLocation === "US" ? (
                  <Subtotal_US />
                ) : (
                  <Subtotal_Korea />
                )} */}
                <Subtotal_Korea />

                {!currentUser && (
                  <>
                    <HashLink
                      smooth
                      to={
                        currentLocation === "US"
                          ? "/checkout_US"
                          : "/checkout_Korea"
                      }
                    >
                      <button
                        className="custom_btn"
                        style={{ marginTop: "20px" }}
                      >
                        {t("guest_checkout_cart")}
                      </button>
                    </HashLink>
                    <HashLink smooth to="/login">
                      <button
                        className="custom_btn_whitebgBorder"
                        style={{ marginTop: "20px" }}
                      >
                        {t("login")}
                      </button>
                    </HashLink>
                  </>
                )}
                {currentUser && (
                  <>
                    {basket?.length === 0 ? (
                      <button className="custom_btn" onClick={showMsg}>
                        {t("Continue to Shop")}
                      </button>
                    ) : (
                      <>
                        <HashLink
                          smooth
                          to={
                            currentLocation === "US"
                              ? "/checkout_US"
                              : "/checkout_Korea"
                          }
                        >
                          <button className="custom_btn">
                            {t("checkout")}
                          </button>
                        </HashLink>
                        <HashLink smooth to="/products-cleansing#top">
                          <button
                            className="custom_btn_whitebgBorder"
                            onClick={showMsg}
                            style={{ marginTop: "20px" }}
                          >
                            {t("continue to shop")}
                          </button>
                        </HashLink>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            <Box sx={{ mt: 3 }}>
              {t("NEED HELP?")}
              <Box sx={{ textDecoration: "underline", pt: 1 }}>
                <HashLink to="/contact#top">{t("contact_center")}</HashLink>
              </Box>
              <Box sx={{ textDecoration: "underline", pt: 1 }}>
                <HashLink to="/faq/return">
                  {t("Shipping / Return Policy")}
                </HashLink>
              </Box>
            </Box>

            {msg && (
              <Alert severity="info" sx={{ mt: 3 }}>
                {msg}
              </Alert>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ pt: 8, px: { md: 20, sm: 1, xs: 1 } }}>
        <FeaturedProductRecent />
        <FeaturedProductsBestSellers />
      </Box>
    </Fade>
  );
};

export default Cart;
